import React from 'react';
import { Hero } from '../components/Hero';
import { JunkLeadSpiral } from '../components/JunkLeadSpiral';
import { LeadSavedShowcase } from '../components/showcase/LeadSavedShowcase';
import { ProblemSection } from '../components/ProblemSection';
import { RoiLeak } from '../components/RoiLeak';
import { DatabaseWakeUp } from '../components/DatabaseWakeUp';
import { HowItWorksTeaser } from '../components/HowItWorksTeaser';
import { Proof } from '../components/Proof';
import { StackSection } from '../components/StackSection';
import { ProjectMenu } from '../components/ProjectMenu';
import { Guarantee } from '../components/Guarantee';
import { CtaBand } from '../components/CtaBand';
import { usePageTitle } from '../hooks/usePageTitle';
export function Home() {
  usePageTitle('Viridia Analytics | Your team already pays for the tools. I make them produce.');
  return <>
      <Hero data-id="element-557" data-mp="3owlv698opyur" />
      <JunkLeadSpiral data-id="element-558" data-mp="3owcdd8xsmy05" />
      <LeadSavedShowcase data-id="element-559" data-mp="3ovkjc2juh8bz" />
      <ProblemSection data-id="element-560" data-mp="3oyymve48vnl0" />
      <RoiLeak data-id="element-561" data-mp="30wrnkc0kxpdf" />
      <DatabaseWakeUp data-id="element-562" data-mp="30xb7fy9sinu3" />
      <HowItWorksTeaser data-id="element-563" data-mp="30vqak2006st2" />
      <Proof data-id="element-564" data-mp="30w039xcfne2g" />
      <StackSection data-id="element-565" data-mp="30ufbgfhi698a" />
      <ProjectMenu data-id="element-566" data-mp="2vxyc0p4us8fw" />
      <Guarantee data-id="element-567" data-mp="2vxf4m2ctx2g4" />
      <CtaBand data-id="element-568" data-mp="2vyzxzoneqfce" />
    </>;
}